exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container .article-container .title[data-v-4098e010]{display:inline-block;cursor:pointer}.container .article-container .title[data-v-4098e010]:hover{-webkit-text-decoration:underline #2e5aff;text-decoration:underline #2e5aff;color:#2e5aff}.article-detail-container[data-v-4098e010]{height:400px}.article-detail-container .title[data-v-4098e010]{text-align:center}.article-detail-container .content[data-v-4098e010]{height:calc(100% - 50px);overflow-y:scroll}", ""]);

// exports
